
















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Form } from 'element-ui'
import { IRadiusForm, IZipListItem } from '@/api/types-fip'
import { getZipsByRadius, updateVendorCoverageSetZipList } from '@/api/vendors'
import EditZipRadiusTable from './EditZipRadiusTable.vue'
import VendorInspectionTypes from './VendorInspectionTypes.vue'
import { IVendorCoverage } from '@/api/types-vendor'

@Component({
  name: 'EditRadiusDialog',
  components: {
    EditZipRadiusTable,
    VendorInspectionTypes
  }
})
export default class extends Vue {
  @Prop({ default: false }) dialogVisible!: boolean;
  @Prop({ default: 0 }) vendorId!: number;
  @Prop({ type: Object }) value!: IRadiusForm;
  private zipList: IZipListItem[] = []
  private zipListLoading = true
  private zipListTitle = ''
  vendorCoverage: IVendorCoverage = {
    vendorCoverageId: 0, // this.value.vendorCoverageId,
    vendorCoverageSetId: 0,
    allCounty: false,
    stateFips: '0',
    state: '',
    countyFips: '0',
    county: '',
    city: '',
    postalCode: '',
    lenderRestriction: '',
    inspType1: true,
    inspType2: true,
    inspType3: true,
    inspType4: true,
    inspType5: true,
    distance: 0,
    zipList: []
  }

  private defaultRadiusForm: IRadiusForm = {
    vendorId: 0,
    vendorCoverageSetId: 0,
    radius: 10,
    selectedZips: []
  }

  private radiusForm = Object.assign({}, this.defaultRadiusForm)

  private loading = false

  private validateRequire = (rule: any, value: string, callback: Function) => {
    if (value === '') {
      callback(new Error(rule.field + ' is required'))
    } else {
      callback()
    }
  }

  private rules = {
    name: [{ validator: this.validateRequire }]
  }

  created() {
    this.radiusForm = Object.assign({}, this.value)
  }

  handleClose() {
    this.$emit('close', true)
  }

  async handleFindZips() {
    console.debug(`handleFindZips ${this.radiusForm.vendorId} ${this.radiusForm.radius}`)
    this.zipListTitle = 'Loading, please wait...'
    this.zipListLoading = true
    const vendorId = this.radiusForm.vendorId
    let list = this.zipList
    const response = await getZipsByRadius(vendorId, this.radiusForm.radius)
    list = response.data

    this.zipList = list
    this.zipListLoading = false
    this.zipListTitle = `There are ${list.length} Zip codes within a ${this.radiusForm.radius} mile distance of your location.`
  }

  async handleZipDelete(row: IZipListItem) {
    console.debug(`Zip delete ${row.zip}`)
    this.zipList.forEach((item, index, array) => {
      if (item.zip === row.zip) {
        array.splice(index, 1)
      }
    })
  }

  async handleZipDeleteMultiple(ids: number[]) {
    console.debug(`Zip delete Multiple ${ids}`)
    ids.forEach((id) => {
      this.zipList.forEach((item, index, array) => {
        if (item.zip === id) {
          array.splice(index, 1)
        }
      })
    })
  }

  submitForm() {
    (this.$refs.radiusForm as Form).validate(async valid => {
      console.debug('Coverage Set Submit')
      if (valid) {
        this.loading = true
        // copy the Inspection Types over to the ZipList befors submitting
        this.vendorCoverage.zipList = this.zipList
        this.radiusForm.selectedZips = this.zipList
        console.debug(`Zip Radius save ${this.radiusForm.selectedZips.length}`)
        updateVendorCoverageSetZipList(this.radiusForm.vendorId, this.radiusForm.vendorCoverageSetId, this.vendorCoverage).then(() => {
          // re-fetch the vendor
          // this.fetchData(this.radiusForm.vendorId)

          this.loading = false
          this.$notify({
            title: 'Success',
            message: `Vendor Coverage Set ${this.radiusForm.vendorCoverageSetId} saved successfully.`,
            type: 'success',
            duration: 3000
          })
          this.dialogVisible = false
          this.handleClose()
          return true
        }, () => {
          // Server Error!? is displayed in request.ts
          console.log('Server-side error!')
        })
      } else {
        console.log('Validation errors!')
      }
      this.loading = false
      return false
    })
  }

  cancelForm() {
    this.dialogVisible = false
  }
}
